import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useAppDispatch } from "../../../../../hooks/hooks";
import { selectCurrent } from "../../../../../redux/settings/selectors";
import { selectListItems } from "../../../../../redux/library/selector";
import Table from "../../../../../common/components/table-manager/v1.1/table";
import PageLoader from "../../../../../components/PageLoader";
import { packagingType } from "../../../../../redux/packaging-types/action";
import { settings } from "../../../../../redux/settings/actions";
import { selectPackagingTypeCreatedItem, selectPackagingTypeDeletedItem, selectPackagingTypeListItems, selectPackagingTypeUpdatedItem } from "../../../../../redux/packaging-types/selector";
const GlobalPackageTypes = () => {
    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    const result = useSelector(selectCurrent)
    const [pageData, setPageData] = useState(1)
    const [pageSize, setPageSize] = useState(10);
    const [categoriesComparisonData, setCategoriesComparisonData] = useState<any>();
    const [categoriesListData, setAdminLevelOneListData] = useState<any>();
    const [uploadFor, setUploadFor] = useState('create');
    const [showComparisonPopup, setShowComparisonPopup] = useState<boolean>(false);
    const { header, footer, currency } = result
    const libraryData = useSelector(selectListItems)
    const listGlobalPackagingTypeReducerData = useSelector(selectPackagingTypeListItems)
    const createPackagingTypeData = useSelector(selectPackagingTypeCreatedItem)
    const comparePackagingTypeData = useSelector(selectPackagingTypeCreatedItem)
    const updatePackagingTypeData = useSelector(selectPackagingTypeUpdatedItem)
    const deletePackagingTypeData = useSelector(selectPackagingTypeDeletedItem)
    const [columnDefs, setColumnDefs] = useState({});
    const [searchCriteriaList, setSearchCriteriaList] = useState<any>([]);

    const createColumnDefs: any = () => {
        setColumnDefs([
            {
                field: "Sl",
                sortable: false,
                filter: false,
                isSortLabel: true,
                headerName: "Sl",
                cellRenderer(params: any) {
                    return parseInt(params.node.id, 10) + 1;
                },
            },

            // Name
            {
                field: "Name",
                headerName: "Name",
                searchField: "Name",
                sortable: true,
                filter: true,
                filterType: "text",
            },

            // Code
            {
                field: "Code",
                headerName: "Code",
                searchField: "Code",
                sortable: true,
                filter: true,
                filterType: "text",
            },
            { field: 'IsActive', headerName: 'Is Active', sortable: true, filter: true, filterType: 'text', cellRenderer: 'yesNoRenderer' },

            // Created On
            {
                field: "CreatedOnUtc",
                headerName: "Created On",
                searchField: "CreatedOnUtc",
                sortable: true,
                filter: true,
                filterType: "text",
                cellRenderer: (params: any) => {
                    return params?.value
                        ? new Date(params.value).toLocaleDateString()
                        : "--";
                },
            },

            // Modified On
            {
                field: "ModifiedOnUtc",
                headerName: "Modified On",
                searchField: "ModifiedOnUtc",
                sortable: true,
                filter: true,
                filterType: "text",
                cellRenderer: (params: any) => {
                    return params?.value
                        ? new Date(params.value).toLocaleDateString()
                        : "--";
                },
            },
        ]);
    };

    const fetchpackagingType = async () => {
        await dispatch(packagingType.resetAction({ actionType: 'list' }))
        await dispatch(packagingType.list({
            url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/global-dbn-reference/global-packaging-types/fetch`,
            entity: 'packagingType',
            jsonData:
            {
                "Context": {},
                "Records": [
                    {}
                ],
                "Pagination": {
                    "PageNumber": pageData,
                    "PageSize": pageSize,
                    "SortField": "GlobalPackagingTypeId",
                    "SortOrder": "desc"
                }
            }
        }))
    }

    const handleAdd = () => {
        navigate(`${0}`)
    }

    const handleSelect = (data: any) => {
    }

    const handleEdit = (data: any) => {
        navigate(`${data.GlobalPackagingTypeId}`)
    }

    const handleSearch = async (data: any) => {
        let searchCriteria = {};
        if (data?.column) {
            searchCriteria = [{
                FieldName: data?.column || data?.searchCriteriaList,
                FieldText: data?.column || data?.searchCriteriaList,
                FieldType: 'text',
                FilterOperatorId: data?.filterOperatorId || 6,
                FieldValue: data?.value
            }]
        } else {
            searchCriteria = [{
                FieldName: "Name",
                FieldText: "Name",
                FieldType: 'text',
                FilterOperatorId: 6,
                FieldValue: data?.value
            }]
        }
        await dispatch(packagingType.resetAction({ actionType: 'list' }))
        await dispatch(packagingType.list({
            url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/global-dbn-reference/global-packaging-types/fetch`,
            entity: 'packagingType',
            jsonData:
            {
                "Context": {},
                "Records": [
                    {}
                ],
                "Pagination": {
                    "PageNumber": pageData,
                    "PageSize": pageSize,
                    "SortField": "GlobalDBNDomainId",
                    "SortOrder": "desc",
                    "Searches": searchCriteria,
                }
            }
        }));
    }


    const additionButtons: any = [
        {
            name: (
                <div className="flex items-center gap-2">
                    {/* Plus Icon */}
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                    >
                        <path
                            d="M12 5V19M5 12H19"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </svg>
                </div>
            ),
            callback: () => handleAdd(),
        },
        {
            svg:
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
                    <title>Reload this table</title>
                    <path d="M21 3V8M21 8H16M21 8L18 5.29168C16.4077 3.86656 14.3051 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.2832 21 19.8675 18.008 20.777 14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>,
            // name: 'Reload',
            callback: () => handleReloadData(),
        },
    ];

    const handleReloadData = () => {
        fetchpackagingType();
    }

    const handleUploadCategoriesClick = () => {
        setUploadFor('create')
        dispatch(settings.set({ getUploadModal: 'open' }))
    };

    const handleCompareCategoriesClick = () => {
        setUploadFor('compare')
        dispatch(settings.set({ getUploadModal: 'open' }))
    };


    const handleDelete = async (data: any) => {
        await dispatch(packagingType.resetAction({ actionType: 'delete' }))
        await dispatch(packagingType.delete({
            url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/global-dbn-reference/global-packaging-types/delete`,
            entity: 'adminLevelOne',
            jsonData: {
                Context: {},
                Records: [
                    {
                        Id: data?.GlobalPackagingTypeId

                    }
                ]
            }
        })).then(() => {
            fetchpackagingType();
        });
    }


    useEffect(() => {
        const searchCriteria: any = listGlobalPackagingTypeReducerData?.result?.items
            ?.filter((item: any) => item?.Message?.SpecificationAttributeName) // Filter out items with falsy SpecificationAttributeName
            ?.map((item: any) => ({
                FieldName: item.Message.SpecificationAttributeName,
            }));
        setSearchCriteriaList(searchCriteria)
    }, [listGlobalPackagingTypeReducerData]);

    useEffect(() => {
        if (listGlobalPackagingTypeReducerData?.isSuccess) {
            setAdminLevelOneListData(listGlobalPackagingTypeReducerData)
            dispatch(packagingType.resetAction({ actionType: 'list' }))
        }
    }, [listGlobalPackagingTypeReducerData]);

    useEffect(() => {
        if (createPackagingTypeData?.isSuccess) {
            dispatch(packagingType.resetAction({ actionType: 'create' }))
            fetchpackagingType();
            toast.info('Routing Model created successfully.')
        }
    }, [createPackagingTypeData]);

    useEffect(() => {
        if (updatePackagingTypeData?.isSuccess) {
            dispatch(packagingType.resetAction({ actionType: 'update' }))
            toast.info('Routing Model updated successfully.')
        }
    }, [updatePackagingTypeData]);

    useEffect(() => {
        if (deletePackagingTypeData?.isSuccess) {
            dispatch(packagingType.resetAction({ actionType: 'delete' }))
            toast.info('Routing Model deleted successfully.')
        }
    }, [deletePackagingTypeData]);

    useEffect(() => {
        if (comparePackagingTypeData?.isSuccess) {
            setCategoriesComparisonData(comparePackagingTypeData)
            setShowComparisonPopup(true)
            dispatch(listGlobalPackagingTypeReducerData.resetAction({ actionType: 'uploadCompare' }))
            // toast.info('Comparison completed successfully.')
        }
    }, [comparePackagingTypeData]);

    useEffect(() => {
        createColumnDefs()
        fetchpackagingType()
        setShowComparisonPopup(false)
        dispatch(packagingType.resetAction({ actionType: 'create' }))
        dispatch(packagingType.resetAction({ actionType: 'uploadCreate' }))
        dispatch(packagingType.resetAction({ actionType: 'uploadCompare' }))
        dispatch(packagingType.resetAction({ actionType: 'update' }))
        dispatch(packagingType.resetAction({ actionType: 'delete' }))
    }, [pageData, pageSize])

    return (
        <>

            {listGlobalPackagingTypeReducerData?.isLoading ||
                createPackagingTypeData?.isLoading ||
                updatePackagingTypeData?.isLoading ||
                deletePackagingTypeData?.isLoading ||
                comparePackagingTypeData?.isLoading ? <PageLoader /> :
                <Table
                    columnData={columnDefs}
                    rowData={categoriesListData?.result?.items}
                    enableFilter={true}
                    setPageData={setPageData}
                    setPageSize={setPageSize}
                    paginationData={categoriesListData?.result?.pagination}
                    onSearch={handleSearch}
                    searchCriteriaList={searchCriteriaList}
                    onSelect={handleSelect}
                    onEdit={handleEdit}
                    onDelete={handleDelete}
                    additionButtons={additionButtons}
                    checkboxConfig={{
                        allowMultiSelect: true,
                        defaultSelectedIds: [],
                        isDisabled: false,
                        keyColumn: 'GlobalPackagingTypeId',
                    }}
                    headingName="Global Packaging Type"
                />
            }
        </>
    );
};

export default GlobalPackageTypes;

